import { Injectable } from '@angular/core';
import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root',
})
export class ModalPortalService {
  // tslint:disable-next-line:variable-name
  private _components: (TemplatePortal | ComponentPortal<any>)[] = []; // Ahora puede contener TemplatePortal o ComponentPortal

  get components(): (TemplatePortal | ComponentPortal<any>)[] {
    return this._components;
  }

  set components(value: (TemplatePortal | ComponentPortal<any>)[]) {
    this._components = value;
  }

  constructor() {}

  public closeModal(): void {
    this.components.pop();
  }
}
